export default "__VITE_ASSET__DBGRDi4P__"